import { z } from 'zod'

export const fuelTanksSchema = z.object({
  // TODO: add fuel tanks fields
})
